// extracted by mini-css-extract-plugin
module.exports = {"doctor-hospital":"doctor-hospital-428d650d0cace69843beff1ce5edd624"};